import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

// create a keyframe to make a full rotation.
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

// Container Div for svg icon (this will create a rotating svg for child svg)
export const StyledLoaderDiv = styled.div`
  & svg {
    display: inline-block;
    animation: ${rotate} 0.5s linear infinite;
  }
`;
